<template>
  <section class="cta-section" style="padding:100px 2rem;">
    <div class="container">
      <div class="section-label fade-up">{{ $t('cta.label') }}</div>
      <h2 class="section-title centered fade-up fade-up-delay-1" v-html="titleHtml"></h2>
      <p class="section-desc centered fade-up fade-up-delay-2">{{ $t('cta.desc') }}</p>
      <div class="fade-up fade-up-delay-3" style="display:flex;justify-content:center;margin-top:2.5rem;">
        <router-link :to="{ name: 'signUp' }" class="btn-white">
          {{ $t('cta.btn') }}
          <svg style="width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:2.5;" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'CtaSection',
    computed: {
      titleHtml() {
        return this.$t('cta.title').replace('\n', '<br/>')
      }
    }
  }
</script>

<style scoped>
.cta-section {
  background: linear-gradient(135deg, var(--primary-dark) 0%, #2a5a7e 100%);
  position: relative;
  overflow: hidden;
  text-align: center;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: -100px; right: -100px;
  width: 400px; height: 400px;
  border-radius: 50%;
  background: rgba(255,255,255,0.04);
  pointer-events: none;
}

.cta-section::after {
  content: '';
  position: absolute;
  bottom: -80px; left: -80px;
  width: 300px; height: 300px;
  border-radius: 50%;
  background: rgba(255,255,255,0.04);
  pointer-events: none;
}

.cta-section :deep(.section-label) {
  background: rgba(255,255,255,0.12);
  color: rgba(255,255,255,0.8);
  border-color: rgba(255,255,255,0.2);
}

.cta-section :deep(.section-title) {
  color: white;
  margin: 0 auto 1rem;
}

.cta-section :deep(.section-desc) {
  color: rgba(255,255,255,0.7);
  margin: 0 auto 2.5rem;
}

.btn-white {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0.9rem 2rem;
  background: white;
  color: var(--primary-dark);
  font-size: 1rem;
  font-weight: 700;
  border-radius: var(--radius-md);
  border: none;
  cursor: pointer;
  transition: transform var(--transition), box-shadow var(--transition);
  box-shadow: 0 4px 18px rgba(0,0,0,0.2);
}

.btn-white:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(0,0,0,0.25); }
</style>
